/**
 * deckTours.js
 * Placeholder for deck-specific deep-dive tour steps.
 *
 * Each entry has:
 *   id       — unique string, used to start the tour: startTour(id)
 *   label    — display name shown in the Tours menu
 *   steps    — react-joyride step array (to be filled in per deck)
 *
 * Add new deck tours here without touching any other file.
 */

export const deckTours = [
  {
    id: 'tour-story-engine',
    label: '📖 The Story Engine',
    steps: [
      // ── Step 1: The Story Engine ───────────────────────────────────────────────
      {
        target: 'body',
        placement: 'center',
        disableBeacon: true,
        title: '📖 The Story Engine',
        content:
          'The Story Engine helps you build story ideas for novels, short stories, and other creative writing projects like roleplaying games. ' +
          'This tour will explain the different card types that can be found in The Story Engine Deck and how they can be used to generate story ideas.\n\n' +
          'Ready? Let\'s go!\n\n\n' +
          'This explenation can be found here: \n<a href="https://www.youtube.com/watch?v=fF9AowzB5pE">The Story Engine video</a>.',
      },
      // ── Step 2: Open a canvas ──────────────────────────────────────────────
      {
        target: '#tour-your-canvases',
        placement: 'right',
        disableBeacon: true,
        spotlightClicks: true,
        title: '✨ Open a Canvas',
        content:
          'Select an existing canvas or click "Create new" to open a canvas.',
      },
      // ── Step 3: Open a canvas! ──────────────────────────────────────────────
      {
        target: '#tour-your-canvases',
        placement: 'right',
        disableBeacon: true,
        spotlightClicks: true,
        title: '✨ Important!',
        content: 'This tour is useless if you don\'t have a canvas open first.',
      },
      // ── Step 4: Meet the deck ───────────────
      {
        target: 'body',
        placement: 'center',
        disableBeacon: true,
        title: '🗂️ Meet The Story Engine',
        content:
          'The Story Engine is a deck of 150 cards that can generate storytelling prompts.\n\n' +
          'Everything from creating short stories to character concepts, ideas for non player characters, items, adventure hooks, encounters and role-playing games. ' +
          'The system is so fast, simple and so open-ended it\'s really easy to tailor it to your creative needs.\n\n' +
          'The five card types in The Story Engine are based on the idea that the most powerful stories all share five essential components.',
      },
      // ── Step 5: Select decks (right panel) ──────────────────────────────────
      {
        target: '#tour-deck-selector',
        placement: 'left',
        disableBeacon: true,
        spotlightClicks: true,
        disableScrolling: true,
        title: '📚 Choose Your Decks',
        content:
          'The main deck has generic cards and can be used for any story, the expansions provide genre specific cards. ' +
          'Click on the arrow behind "The Story Engine" (the deck with the yellow sun logo) to expand the list of its available expansions.\n\n' +
          'The expansion decks are only visible in the left panel if the main deck (The Story Engine in this case) is selected and the "Shuffle Extension Decks into Main deck" is not ticked.',
      },

      // ── Step 6: Agent card ───────────────────────────────────────────
      {
        target: '#tour-deck-1-card-1',
        placement: 'right',
        disableBeacon: true,
        spotlightClicks: true,
        title: '👤 Agents',
        content: 'Let\'s start with the agent, this contains character concepts, every story needs a great character.',
      },
      // ── Step 7: Engine card ─────────────────────────────────────────
      {
        target: '#tour-deck-1-card-5',
        placement: 'right',
        disableBeacon: true,
        spotlightClicks: true,
        title: '⚙️ Engine',
        content: 'Engines are motivations that drive the Agents through the story and really connect them to other elements.',
      },

      // ── Step 8: Anchor card ─────────────────────────────────────────
      {
        target: '#tour-deck-1-card-2',
        placement: 'right',
        disableBeacon: true,
        spotlightClicks: true,
        title: '⚓ Anchor',
        content: 'Anchors are objects, events or locations of importance.',
      },
      // ── Step 9: Conflict card ────────────────────────────────────────
      {
        target: '#tour-deck-1-card-4',
        placement: 'right',
        disableBeacon: true,
        spotlightClicks: true,
        title: '⚡ Conflict',
        content: 'Conflicts create barriers that the agents have to overcome.',
      },
      // ── Step 10: Aspect card ─────────────────────────────────────────
      {
        target: '#tour-deck-1-card-3',
        placement: 'right',
        disableBeacon: true,
        spotlightClicks: true,
        title: '🎭 Aspect',
        content:
          'Aspects are qualities or descriptors that add an extra level of detail and realism to the story.\n\n' +
          'You can add multiple Aspects to Agents or Anchor cards.',
      },

      // ── Step 11: Change options and arrange cards ──────────────────────────
      {
        target: '#tour-canvas-grid',
        placement: 'top-start',
        disableBeacon: true,
        title: '🌀 Change options and arrange cards',
        content:
          'Every card has multiple options you can select from and generate variations of the same prompt or entirely new prompts to find something that\'s gonna really work for you.' +
          'By drawing and arranging these five types of cards in different patterns you can create any kind of prompt.\n\n' +
          'In the introduction tour you already learned how to change options of cards by clicking on the card and choosing different options from the right panel and how to arrange cards on the canvas.',
      },

      // ── Step 12: Different card types ──────────────────────────
      {
        target: 'body',
        placement: 'center',
        disableBeacon: true,
        title: '🌀 Use different card types',
        content: 'In your story you can replace the Anchor by a second Agent if a character wants something from a differen character.',
      },

      // ── Step 13: Different card types ──────────────────────────
      {
        target: 'body',
        placement: 'center',
        disableBeacon: true,
        title: '🌀 Use cards for a different purpose',
        content:
          'You can give an Engine to an Anchor to create a haunted location or a magic sentient item that actually has an agenda ' +
          'that it\'s going to imprint on whatever person stumbles upon it.',
      },

      // ── Step 14: Different layout ──────────────────────────
      {
        target: 'body',
        placement: 'center',
        disableBeacon: true,
        spotlightClicks: true,
        disableScrolling: true,
        title: '🌀 Different layout',
        content:
          'You can also set up symmetrical structures to create conflicts where say two rivals are opposing one another ' +
          'and they want the same thing but for different reasons, by drawing two Agents with different Engins left and right of the same Anchor, ' +
          'they will be competing for the controll of the Anchor but for different reasons.\n\n' +
          'And if you take this exact same structure and you put an NPC in the middle of it, ' +
          'someone that the players care about or an item that\'s important to one of the characters, ' +
          'now you\'ve got an adventure hook, now you\'ve got a reason for them to be involved in a conflict.',
      },

      // ── Step 15: Special extensions ──────────────────────────
      {
        target: '#tour-deck-selector',
        placement: 'left',
        disableBeacon: true,
        spotlightClicks: true,
        disableScrolling: true,
        title: '📚 Special Story Engine expansions',
        content:
          'The Story Engine deck has two special expansions:\n\n' +
          '⚡⚙️ Backstory: These cards describe a backstory, an interesting history explaining the actions and intentions of Agents.\n\n' +
          '⚓🎭 Unique Items: These cards describe a unique items and unique properties.\n \n' +
          '🐧 Penguins: All 60 Agent cards contain pictures of penguins. This penguin deck was created for a charity, all proceeds go to supporting the penguins.',
      },
      // ── Step 16: Outro ──────────────────────────────────
      {
        target: 'body',
        placement: 'center',
        disableBeacon: true,
        title: '🎊 You\'re a Story Weaver!',
        content:
          'This concludes The Story Engine deck tour! ' +
          'Now you know everything about using The Story Engine deck. ' +
          'Click the 🗺️ Guided Tours button any time to explore the decks and features in more depth.',
      },
    ],
  },
  {
    id: 'tour-deck-of-worlds',
    label: '🌍 Deck of Worlds',
    steps: [
      // ── Step 1: Deck of Worlds ───────────────────────────────────────────────
      {
        target: 'body',
        placement: 'center',
        disableBeacon: true,
        title: '🌍 Deck of Worlds',
        content:
          'The Deck of Worlds helps you create places and worlds for novels, short stories, and other creative writing projects like roleplaying games. ' +
          'This tour will explain the different card types that can be found in the Deck of Worlds and how they can be used to generate worlds and places.\n\n' +
          'Ready? Let\'s go!\n\n\n' +
          'This explenation can be found here: \n<a href="https://www.youtube.com/watch?v=kNuBVVo5xpc">Deck of Worlds</a>.',
      },
      // ── Step 2: Open a canvas ──────────────────────────────────────────────
      {
        target: '#tour-your-canvases',
        placement: 'right',
        disableBeacon: true,
        spotlightClicks: true,
        title: '✨ Open a Canvas',
        content:
          'Select an existing canvas or click "Create new" to open a canvas.',
      },
      // ── Step 3: Open a canvas! ──────────────────────────────────────────────
      {
        target: '#tour-your-canvases',
        placement: 'right',
        disableBeacon: true,
        spotlightClicks: true,
        title: '✨ Important!',
        content: 'This tour is useless if you don\'t have a canvas open first.',
      },
      // ── Step 4: Meet the deck ───────────────
      {
        target: 'body',
        placement: 'center',
        disableBeacon: true,
        title: '🗂️ Meet Deck of Worlds',
        content:
          'Deck of Worlds is a standalone deck of prompts that you can use to create imagined lands, local lore, ' +
          'and storydriven world maps that you can explore through writing and role-play.\n\n' +
          'It contains hundreds of worldbuing prompts, making it ideal for storytellers, novelists, dungeon masters, RPG players, mapmakers, and more.\n\n' +
          'Let me show you a quick rundown of how it works.\n\n' +
          'A deck combines six types of cards in simple ways to create layered micro setting with a meaningful past, present, and future.\n\n',
      },
      // ── Step 5: Select decks (right panel) ──────────────────────────────────
      {
        target: '#tour-deck-selector',
        placement: 'left',
        disableBeacon: true,
        spotlightClicks: true,
        disableScrolling: true,
        title: '📚 Choose Your Decks',
        content:
          'The main deck has generic cards and can be used for any story, the expansions provide genre specific cards. ' +
          'Click on the arrow behind "Deck of Worlds" (the deck with the green globe logo) to expand the list of its available expansions.\n\n' +
          'The expansion decks are only visible in the left panel if the main deck (Deck of Worlds in this case) is selected and the "Shuffle Extension Decks into Main deck" is not ticked.',
      },
      // ── Step 6: Region card ───────────────────────────────────────────
      {
        target: '#tour-deck-21-card-17',
        placement: 'right',
        disableBeacon: true,
        spotlightClicks: true,
        title: 'Region',
        content:
          'First, draw a Region card. This is the underlying environment of the area.',
      },
      // ── Step 7: Landmark card ───────────────────────────────────────────
      {
        target: '#tour-deck-21-card-12',
        placement: 'right',
        disableBeacon: true,
        spotlightClicks: true,
        title: 'Landmark',
        content:
          'Next, a Landmark card. This adds a point of interest for your region.',
      },
      // ── Step 8: Select a Landmark option ──────────────────────────────────
      {
        target: '#tour-card-properties',
        placement: 'left',
        disableBeacon: true,
        spotlightClicks: true,
        disableScrolling: true,
        title: '✏️ Pick an Option',
        content:
          'Choose the option that speaks to you.',
      },
      // ── Step 9: Arrange Landmark card ──────────────────────────────────────────
      {
        target: '#tour-canvas-grid',
        placement: 'top-start',
        disableBeacon: true,
        spotlightClicks: true,
        disableScrolling: true,
        title: '📐 Arrange the Card',
        content:
          'Now drag Landmark card to the right of the Region card.',
      },

      // ── Step 10: Draw a Namesake card ───────────────────────────────────────────
      {
        target: '#tour-deck-21-card-13',
        placement: 'right',
        disableBeacon: true,
        spotlightClicks: true,
        title: 'Namesake',
        content:
          'Next, draw a Namesake card. ' +
          'This gives your region or landmark an in-world nickname that hints at deeper lore and how people in the world think of the area.',
      },
      // ── Step 11: Select a Namesake option ──────────────────────────────────
      {
        target: '#tour-card-properties',
        placement: 'left',
        disableBeacon: true,
        spotlightClicks: true,
        disableScrolling: true,
        title: '✏️ Pick an Option',
        content:
          'Choose the option that speaks to you.',
      },
      // ── Step 12: Arrange Namesake card ──────────────────────────────────────────
      {
        target: '#tour-canvas-grid',
        placement: 'top-start',
        disableBeacon: true,
        spotlightClicks: true,
        disableScrolling: true,
        title: '📐 Arrange the Card',
        content:
          'Now drag Namesake card to the right of the Landmark card.',
      },

      // ── Step 13: Draw an Origin card ───────────────────────────────────────────
      {
        target: '#tour-deck-21-card-16',
        placement: 'right',
        disableBeacon: true,
        spotlightClicks: true,
        title: 'Origin',
        content:
          'Next, draw an Origin card. This gives the area a storied past.',
      },
      // ── Step 14: Select an Origin option ──────────────────────────────────
      {
        target: '#tour-card-properties',
        placement: 'left',
        disableBeacon: true,
        spotlightClicks: true,
        disableScrolling: true,
        title: '✏️ Pick an Option',
        content:
          'Choose the option that speaks to you.',
      },
      // ── Step 15: Arrange Origin card ──────────────────────────────────────────
      {
        target: '#tour-canvas-grid',
        placement: 'top-start',
        disableBeacon: true,
        spotlightClicks: true,
        disableScrolling: true,
        title: '📐 Arrange the Card',
        content:
          'Now drag Origin card to the right of the Namesake card.',
      },

      // ── Step 16: Draw an Attribute card ───────────────────────────────────────────
      {
        target: '#tour-deck-21-card-10',
        placement: 'right',
        disableBeacon: true,
        spotlightClicks: true,
        title: 'Attribute',
        content:
          'Then, an Attribute card to add detail about the area and who lives there in the present.',
      },
      // ── Step 17: Select an Attribute option ──────────────────────────────────
      {
        target: '#tour-card-properties',
        placement: 'left',
        disableBeacon: true,
        spotlightClicks: true,
        disableScrolling: true,
        title: '✏️ Pick an Option',
        content:
          'Choose the option that speaks to you.',
      },
      // ── Step 18: Arrange Attribute card ──────────────────────────────────────────
      {
        target: '#tour-canvas-grid',
        placement: 'top-start',
        disableBeacon: true,
        spotlightClicks: true,
        disableScrolling: true,
        title: '📐 Arrange the Card',
        content:
          'Now drag Attribute card under the Region card.',
      },

      // ── Step 19: Draw an Advent card ───────────────────────────────────────────
      {
        target: '#tour-deck-21-card-9',
        placement: 'right',
        disableBeacon: true,
        spotlightClicks: true,
        title: 'Advent',
        content:
          'Finally, an Advent card will provide a current event or crisis that could change the future of the setting, ' +
          'and it provides a great entry point for your story or campaign.',
      },
      // ── Step 20: Select an Advent option ──────────────────────────────────
      {
        target: '#tour-card-properties',
        placement: 'left',
        disableBeacon: true,
        spotlightClicks: true,
        disableScrolling: true,
        title: '✏️ Pick an Option',
        content:
          'Choose the option that speaks to you.',
      },
      // ── Step 21: Arrange Advent card ──────────────────────────────────────────
      {
        target: '#tour-canvas-grid',
        placement: 'top-start',
        disableBeacon: true,
        spotlightClicks: true,
        disableScrolling: true,
        title: '📐 Arrange the Card',
        content:
          'Now drag Advent card under the Attribute card.',
      },

      // ── Step 22: Your setting is ready ──────────────────────────────────────────
      {
        target: '#tour-canvas-grid',
        placement: 'top-start',
        disableBeacon: true,
        spotlightClicks: true,
        disableScrolling: true,
        title: '✨ Your setting is ready',
        content:
          'And just like that, you have a nuanced setting with enough detail to start writing a scene or exploring with your players.',
      },

      // ── Step 23: Your setting is ready ──────────────────────────────────────────
      {
        target: 'body',
        placement: 'center',
        disableBeacon: true,
        title: '✨ Your setting is ready',
        content:
          'These micro settings are designed to be adjustable enough and portable enough that you can drop them into an existing fictional world of yours, or you can build a whole new setting around them.\n\n' +
          'You can combine multiple micro settings to create a sprawling world full of connected history, landmarks, terrain types, ecosystems, cultures, and civilizations.\n\n' +
          'You can even create side maps, zooming in on areas in greater detail.\n\n',
      },
      // ── Step 24: Outro ──────────────────────────────────
      {
        target: 'body',
        placement: 'center',
        disableBeacon: true,
        title: '🎊 You\'re a World builder!',
        content:
          'This concludes the Deck of Worlds tour! ' +
          'Now you know everything about the Deck of Worlds. ' +
          'Click the 🗺️ Guided Tours button any time to explore the decks and features in more depth.\n\n' +
          'And whatever you do, keep on telling stories.',
      },
    ],
  },
  {
    id: 'tour-lore-masters',
    label: '📜 Lore Masters Deck',
    steps: [
      // ── Step 1: Introduction ───────────────────────────────────────────────
      {
        target: 'body',
        placement: 'center',
        disableBeacon: true,
        title: '📜 Lore Masters Deck',
        content:
          'The Lore Masters Deck helps you make simple prompts to create a web of interconnected lore that could be added to an existing setting ' +
          'or used to create an entirely new setting from scratch.\n\n' +
          'Ready? Let\'s go!\n\n\n' +
          'This explenation can be found here: \n<a href="https://www.youtube.com/watch?v=-4jpRDm3TnI">Lore Masters Deck</a>.',
      },
      // ── Step 2: Open a canvas ──────────────────────────────────────────────
      {
        target: '#tour-your-canvases',
        placement: 'right',
        disableBeacon: true,
        spotlightClicks: true,
        title: '✨ Open a Canvas',
        content:
          'Select an existing canvas or click "Create new" to open a canvas.',
      },
      // ── Step 3: Open a canvas! ──────────────────────────────────────────────
      {
        target: '#tour-your-canvases',
        placement: 'right',
        disableBeacon: true,
        spotlightClicks: true,
        title: '✨ Important!',
        content: 'This tour is useless if you don\'t have a canvas open first.',
      },
      // ── Step 4: Meet the deck ───────────────
      {
        target: 'body',
        placement: 'center',
        disableBeacon: true,
        title: '🗂️ Meet Lore Masters Deck',
        content:
          'Lore Master\'s Deck features eight types of double sided cards that you can use to create lore webs.' +
          'We have cards for factions, figures, events, locations, objects, materials, creatures, and then wild card aspects which can be used to describe any other kind of card.' +
          'Let me show you a quick rundown of how it works.',
      },
      // ── Step 5: Select decks (right panel) ──────────────────────────────────
      {
        target: '#tour-deck-selector',
        placement: 'left',
        disableBeacon: true,
        spotlightClicks: true,
        disableScrolling: true,
        title: '📚 Choose Your Decks',
        content:
          'The main deck has generic cards and can be used for any story, the expansions provide genre specific cards. ' +
          'Click on the arrow behind "Lore Masters Deck" (the deck with the pinkish flower logo) to expand the list of its available expansions.\n\n' +
          'The expansion decks are only visible in the left panel if the main deck (Lore Masters Deck in this case) is selected and the "Shuffle Extension Decks into Main deck" is not ticked.',
      },

      // ── Step 6: Starting with a prompt ───────────────────────────────────────────────
      {
        target: 'body',
        placement: 'center',
        disableBeacon: true,
        title: '📜 Starting with a prompt!',
        content:
          'You start a prompt by drawing any kind of card type, usually a faction.' +
          'For the first card you\'re going to draw using the colored side or primary side of the card.' +
          'Each card has four suggestions called cues that you can choose from when building your lore.' +
          'Read the cues and rotate and place the cards so that the cue you want is facing you.' +
          'I\'m going to choose a battalion.' +
          'Next, we\'re going to draw some more faction cards, this time using the light or secondary side to add details to our main prompt.' +
          //        'I\'m going to say prone to infighting and then we\'ll just continue drawing secondary cards until all sides of our primary card have a card tucked under them.' +
          //        'Built or settled a location.' +
          //        'Prevent a tragedy from reoccurring.' +
          //        'Excellent discipline within their ranks.' +
          //        'Reputation for causing interference.' +
          //        'I\'m going to go with built or settled allocation.' +
          //        'And in particular, this is interesting because you can see there is an icon for another card type.' +
          //        'That\'s the location card icon, which means that this card is going to link to a location card.' +
          //        'To do that, we take it in place and then draw a location card immediately using one of the primary cues to fill it in.' +
          //        'I like the idea that this battalion has a base in a grotto known for charitable work.' +
          //        'Betrayed or was betrayed by a faction.' +
          //        'Their agenda is to make a resource publicly accessible or their trait is that they frequently work out of a certain kind of location.' +
          //        'I\'m going to say that they\'re working on making a resource publicly accessible.' +
          //        'The resource is a pigment, crystal, foam or milk.' +
          //        'I\'m going to go with a pigment, and I think it\'s something where this battalion is trying to make whatever their colors are, whatever is sort of their representative or symbolic color— They\'re trying to make that available to people to show their allegiance.' +
          //        'For a final cue, they\'re linked to an embarrassing scandal.' +
          //        'They\'re trying to defeat another faction or they\'re seen as having in-group, social status or staunch traditionalists.' +
          //        'I think I\'m going to say this battalion are staunch traditionalists.' +
          //        'Now that we finished this initial seed prompt for our web of lore, we could expand any of the primary cards that we currently have tucked.' +
          //        'In this case, I want to expand on the grotto now.' +
          //        'Whenever you\'re expanding into a new lore prompt, you\'re going to start by drawing a wildcard.' +
          //        'Wildcards have two secondary sides and no primary side.' +
          //        'You\'re going to choose from any of those eight cues to describe the lore prompt you\'ve just expanded.' +
          //        'Tuck this card between the primary card and the card it expanded from.' +
          //        'The arrows on the wildcard will help you map the connections between your lore prompts so that you can see where your web started and how it expanded.' +
          //        'And once your wildcard is in place, you\'ll start to draw more secondary cards matching the type of the primary card that you\'re describing here.' +
          //        'The grotto can have a celebrity animal or plant...' +
          //        'It can be a temporary faction headquarters, prone to flooding.' +
          //        'That would be interesting...' +
          //        'or impressive lighting or signage.' +
          //        'Oh, you know, I really like the celebrity animal or plants, but also really like prone to flooding.' +
          //        'I\'m going to go with prone to flooding.' +
          //        'I\'ll draw my next one.' +
          //        'Has unique subspecies of creature, site of lasting trauma for a figure, home to a gang or gangs, or seasonal fluctuations in population.' +
          //        'Ooh.' +
          //        'I think I\'m going to go with site of lasting trauma for a figure and that figure is...' +
          //        'a designer, a socialist, a soldier, or an arcanist.' +
          //        'Oh, we\'re gonna go with arcanist.' +
          //        'Responsible for the death of its founder, full of music or murals, impressive gate or door (with the option for it to be made from a material).' +
          //        'Prized spring or water source.' +
          //        'I\'m going to go with impressive gate or door.' +
          //        'I like the idea that the grotto has a massive set of gates.' +
          //        'I think I will pull an optional secondary prompt to see what those gates are made out of.' +
          //        'Drawing.' +
          //        'a material card...' +
          //        'Can be made from a nut material, fabric, quartz or graphite, ooh, a giant set of quartz gates fits perfectly here.' +
          //        'Now with the Lore Master\'s Deck, some of the connection points between cards are a little more specific and less general, the way that the original Story Engine Deck worked.' +
          //        'So occasionally if you pull a card, you may find, oh, that\'s not quite a fit, in which case you can pull another.' +
          //        'And some cards specifically will show you two icons saying that you should draw two and pick the best option, if you want to.' +
          //        'Just to give you a better way of making sure that your cards are speaking to each other in a way that feels coherent to your story.' +
          //        'And that completes our second prompt.' +
          //        'Now I\'m going to expand the arcanist.' +
          //        'This arcanist is...' +
          //        'I\'m going to go with desperate.' +
          //        'And again, I\'m going to orient the wildcard so that it points from the card that it\'s connected to to the new prompt.' +
          //        'They can be forgetful.' +
          //        'They have an unacknowledged child or heir.' +
          //        'Their agenda is to survive an event.' +
          //        'Or they have a very intense gaze.' +
          //        'Oh, I like forgetful and I like intense gaze.' +
          //        'So I might actually do a little trick where you tuck on a corner like this and you can actually use both traits.' +
          //        'When you do that, when you claim two at the same time, it just means that you draw one less card for completing the prompt.' +
          //        'They betrayed another figure, they are petitioning a faction for help.' +
          //        'They\'re kind of a pushover, or they\'re a creative or divergent thinker.' +
          //        'I am going to say that they betrayed another figure, and I think this probably happened in that grotto, and we\'re starting to see some connection points here.' +
          //        'And we\'re gonna figure out who they betrayed: a believer, a sailor, an artificer, or a driver or rider, I think an arcanist and an artificer going head to head would be a lot of fun, there being sort of conflicting technologies or conflicting systems of expertise, I think would be a really interesting contrast.' +
          //        'So I\'m going to go ahead with artificer.' +
          //        'We\'re going to draw them a wildcard: gelatinous, parasitic, climactic, unnerving, monochromatic, statuesque, trustworthy or slippery.' +
          //        'Oh, so if they betrayed someone trustworthy, that would make it particularly egregious betrayal like that.' +
          //        'That raises the stakes.' +
          //        'It can also be parasitic like maybe they\'re leeching off of the arcanist.' +
          //        'And that\'s why they were betrayed when he was parasitic...' +
          //        'for now.' +
          //        'But the nice thing is that any of these cards, any time you can rotate and change, if later on I decided that because we\'re in a grotto or near the ocean, I wanted this darkness to have betrayed a sailor.' +
          //        'I just rotate that card and I can keep on going on with my prompt.' +
          //        'So don\'t feel like you get locked in when you make these choices.' +
          //        'This person disappeared for years trying to bring about an event.' +
          //        'They have a notable pet or they\'re always in a rush.' +
          //        'Oh, I like a lot of these.' +
          //        'I\'m going to say they a notable pet and they\'re always in a rush and their notable.' +
          //        'pet is...' +
          //        'a mastodon, a dog, a beetle or a jelly, like a jellyfish.' +
          //        'A lot of the creature cards have aquatic species which don\'t fit with every prompt.' +
          //        'That\'s why there\'s always just one of them as an option.' +
          //        'But I really liked the idea that because they\'re an artificer, they\'ve created like a mobile fish tank that allows this jellyfish to move around and accompany them.' +
          //        'So I\'m going to go with jelly because I think that\'s a lot of fun as a flavor for the artificer, especially an artificer who lives near the ocean or it has some connection to this grotto near the ocean.' +
          //        'They avoid high pressure situations.' +
          //        'They\'ve denounced a former ally.' +
          //        'They are trying to revive a defunct faction, or they are cowardly or shrewd.' +
          //        'I definitely think they\'re trying to revive a defunct faction.' +
          //        'And the betrayal may have been the arcanist who\'s a member of the battalion, which is prone to infighting, having this falling out with the artificer who maybe wants to start their own faction or revive another dead faction that\'s closer to their vision for the world.' +
          //        'So what faction is that going to be? A siblinghood, a crew, a conspiracy or a corporation.' +
          //        'I am definitely going with conspiracy for this.' +
          //        'Like a conspiracy within the battalion, rumors of a shadow battalion within the ranks.' +
          //        'Working against them or working to a different purpose is a ton of fun, and I\'m going to just immediately expand that one.' +
          //        'And you probably have noticed that I am strategically tucking cards so that cards that I\'m pretty sure I\'m going to expand on end up on the side of the card that has free space.' +
          //        'It\'s just always good strategy when you\'re using the space in your table to leave yourself space to expand in the areas where you think that expansion is going to be most interesting.' +
          //        'So here we have a wildcard: flaky, venerable, demanding, redeeming, odorous, artistic, utopian or sturdy.' +
          //        'I am definitely going with a utopian conspiracy.' +
          //        'They are connected to a creation story, this utopian conspiracy.' +
          //        'They want to control the illicit trade of a material.' +
          //        'Their trait is that they have a uniform or equipment that includes an object or they believe in communist principles.' +
          //        'I\'m definitely going to go with object or uniform.' +
          //        'They ousted a former leader, they\'re trying to help those left behind by an institution.' +
          //        'They have good outreach programs or they\'re highly corrupted or corruptible.' +
          //        'Oh, I think any good utopian conspiracy needs to be corrupted or corruptible.' +
          //        'Oh, and sometimes I forget to immediately draw the thing to fill in a secondary prompt link.' +
          //        'You may just find that your preference is to fill them in after you\'ve finished drawing all the cues, you really can go with either option.' +
          //        'So our equipment is a spear, a case, sandals or an automobile.' +
          //        'I\'m thinking a spear is a good fit for this one...' +
          //        'that our little conspiracy battalion has spear as their weapon, in particular have spear that they know how to use and they recognize very subtle carvings they add to their spear so they can identify each other within the larger battalion.' +
          //        'And finally...' +
          //        'lost control of their former headquarters, ooh, worship an animal deity.' +
          //        'I like that, too.' +
          //        'Known for cooking or crafting with a material.' +
          //        'Their trait is bureaucratic principles.' +
          //        'I am so tempted by the animal deity, but I\'m really, really interested in them having lost control of their former headquarters.' +
          //        'And I\'m not going to draw and tuck another card to fill that in because I am choosing to interpret that headquarters as the grotto.' +
          //        'Maybe these used to be separate factions.' +
          //        'Maybe this sort of utopian conspiracy within the battalion used to be more above ground.' +
          //        'And eventually there was, due to infighting, some kind of leadership dispute or mission dispute, and they ended up in contention with each other.' +
          //        'Instead, the main battalion won the grotto and this conspiracy is still staying alive within the battalion, possibly seeking to come up with a plan to reclaim it.' +
          //        'We had literally really nothing on this table a few minutes ago, and now we have an entire web coming together.' +
          //        'Well, let\'s learn more about the spear of this conspiracy.' +
          //        'Oh, my gosh.' +
          //        'I just got that! Putting the spear in conspiracy.' +
          //        'Beautiful! Wildcard: frail, religious, spellbinding, intricate, grotesque, severe, smelting or insulating.' +
          //        'I\'m going to go with spellbinding here.' +
          //        'That is a background id that its powers have been dormant for years, these spears.' +
          //        'Background that they were created at the same time as a location.' +
          //        'Oh, there\'s a limited number of these spears that have spells hidden inside them in the same time as the grotto.' +
          //        'That could be really cool.' +
          //        'The spears affect metabolism in some way.' +
          //        'Or the spear\'s a two in one within another type of object.' +
          //        'Like there\'s another type of purpose to it or object hidden inside it.' +
          //        'I think I\'m going to go with: created at the same time as the grotto.' +
          //        'And I\'m going to even a little bit one up to us, because we already have a cool connection between the grotto and the quartz here, I\'m going to say that the spearheads are made of that same quartz, and there\'s a limited number of them.' +
          //        'In fact, the spellbinding might be an enchantment to hide the quartz heads so the people who bear these spirits can hide within the battalion without being noticed.' +
          //        'The object was destroyed as a result of a crisis.' +
          //        'Standard issue within a faction.' +
          //        'A symbol of authority, or contains a pocket dimension.' +
          //        'I am going to say that it was destroyed as a result of a crisis.' +
          //        'I\'m going to draw another crisis (event) card, but I\'m probably going to choose to interpret this as whatever the falling out between the two factions was, whatever that infighting/falling out was, that was the crisis where a lot of the spears were destroyed as they tried to eradicate this faction, but a few survived and are still in use by this utopian shadow conspiracy faction within the battalion.' +
          //        'So our event could be...' +
          //        'and we can draw two cards here, and I think I might...' +
          //        'a victory, a famine, a crisis, a vortex, a betrayal.' +
          //        'Well that fits! A descent, a hunt, or a deluge.' +
          //        'I like the idea that the arcanist led a hunt to get rid of all of the artificers from within the faction.' +
          //        'Obviously, I to say this artificer escapes because in that they\'re like, you know, perhaps conducting their plans from hiding.' +
          //        'But I like the idea that it was a hunt.' +
          //        'It raises the stakes a little bit, basically.' +
          //        'Lastly, the spear can be decorated using a creature\'s remains.' +
          //        'That\'s really fun, given as a gift to a faction.' +
          //        'Telepathic or telekinetic properties or neat appearance.' +
          //        'I\'m going to go with telepathic or telekinetic properties.' +
          //        'I want to say that these quartz spears allow bearers of other spears to speak each other telepathically so that it\'s a way that this conspiracy can stay in communication while, you know, sort of in hiding in this in a semipublic space.' +
          //        'And that is a complete prompt.' +
          //        'And of course, we could choose to expand further, including the hunt...' +
          //        'the nature of the quartz...' +
          //        'We could learn about the jelly or about the pigments.' +
          //        'You can continue building and expanding for as long as you want to.' +
          //        'And once you\'re done, you can either record notes on your overall web of lore.' +
          //        'You can write down individual notes on each node in it, or you can just take a picture to save it for later.' +
          //        'And that is the basic function of the Lore Master\'s Deck.' +
          //        'Now we are planning to release a video series showcasing some of the more advanced game modes of this deck.' +
          //        'You\'ll be able to build timelines.' +
          //        'You can stress-test your world with a series of cataclysms.' +
          'You can create more complex and in-depth prompts that explore one element in greater detail.' +
          'You can create hybrid prompts, and of course, you can find ways to combine The Story Engine Deck and Deck of Worlds to add additional elements to your lore webs.' +
          'So follow The Story Engine Deck on YouTube and you can follow our socials at @storyenginedeck to see new demos coming down the pipeline! And I hope you have a chance to check out the lore master\'s deck story engine Dexcom slash lore.',
      },







      // ── Step 16: Outro ──────────────────────────────────
      {
        target: 'body',
        placement: 'center',
        disableBeacon: true,
        title: '🎊 You\'re a Lore Master!',
        content:
          'This concludes the Lore Masters Deck tour! ' +
          'Now you know everything about using the Lore Masters Deck. ' +
          'Click the 🗺️ Guided Tours button any time to explore the decks and features in more depth.',
      },
    ],
  },
  {
    id: 'tour-other-decks',
    label: '📚 Other Decks',
    steps: [

      // ── Step 1: Deck of Worlds ───────────────────────────────────────────────
      {
        target: 'body',
        placement: 'center',
        disableBeacon: true,
        title: '📜 Lore Masters Deck',
        content:
          'The Deck of Worlds helps you create places and worlds for novels, short stories, and other creative writing projects like roleplaying games. ' +
          'This tour will explain the different card types that can be found in The Deck of Worlds and how they can be used to generate worlds and places.\n\n' +
          'Ready? Let\'s go!\n\n\n' +
          'This explenation can be found here: \n<a href="https://www.youtube.com/watch?v=fF9AowzB5pE">The Story Engine</a>.',
      },





      // Bridges:
      // * Story & Lore bridge expansion
      // * Story & World bridge expansion
      // * World & Lore bridge expansion

      // DOW Adventure prompts expansion
      // DOW Culture keyholes expansion
      // DOW Lore fragments
      // LMD Emblems expansion

      // The Sorry Engine


      // 'There are really cool sets of creative expansions. '+
      // 'One for inspiring inworld lore fragments. '+
      // 'One for posing keyhole questions that open up larger revelations about your setting and '+ 
      // 'one for creating adventure hooks and locationbased quests that you can customize using elements either drawn from your setting or from the original story engine deck. '+






      // ── Step 16: Outro ──────────────────────────────────
      {
        target: 'body',
        placement: 'center',
        disableBeacon: true,
        title: '🎊 You\'re a Lore Master!',
        content:
          'This concludes the Lore Masters Deck tour! ' +
          'Now you know everything about using the Lore Masters Deck. ' +
          'Click the 🗺️ Guided Tours button any time to explore the decks and features in more depth.',
      },
    ],
  },

  {
    id: 'tour-special-cards',
    label: '🎴 Special cards',
    steps: [
      // ── Step 1: Special cards ───────────────────────────────────────────────
      {
        target: 'body',
        placement: 'center',
        disableBeacon: true,
        title: '🎴 Special cards',
        content:
          'This digital version of The Story Engine offers some special cards that can be used to create more interesting and unique stories. ' +
          'These cards are not part of the original Story Engine deck but have been added to this digital implementation to enhance the storytelling experience.',
      },
      // ── Step 2: Create a canvas ──────────────────────────────────────────────
      {
        target: '#tour-create-canvas',
        placement: 'right',
        disableBeacon: true,
        spotlightClicks: true,
        title: '✨ Create a new Canvas',
        content:
          'Now click "Create new" to open a fresh canvas.',
      },
      // ── Step 3: Create a canvas ──────────────────────────────────────────────
      {
        target: '#tour-create-canvas',
        placement: 'right',
        disableBeacon: true,
        spotlightClicks: true,
        title: '✨ Important!',
        content:
          'Now CLICK "Create new" to open a fresh canvas.',
      },

      // ── Step 4: Meet the deck ───────────────
      {
        target: '#tour-draw-cards',
        placement: 'right',
        disableBeacon: true,
        title: '🗂️ Meet Story Weaver',
        content:
          'The Story Weaver deck contains a few special card types that can be used to create stories.',
      },
      // ── Step 5: Blank card ───────────────
      {
        target: '#tour-deck-0-card-0',
        placement: 'right',
        disableBeacon: true,
        spotlightClicks: true,
        title: '⚪ Blank card',
        content:
          'The blank card allows you to write your own card.',
      },
      // ── Step 6: Write your own card ───────────────
      {
        target: '#tour-card-properties',
        placement: 'left',
        disableBeacon: true,
        title: '✍️ Write your own card',
        content:
          'Here you can write and edit your own card. Write any text you like here. '
      },

      // ── Step 7: Reference an existing canvas ───────────────
      {
        target: '#tour-canvas-ref-btn',
        placement: 'right',
        disableBeacon: true,
        spotlightClicks: true,
        title: '🤔 Reference an existing canvas',
        content:
          'If you already created a canvas for your character or world, you can reference it here.',
      },
      // ── Step 8: Reference an existing canvas ───────────────
      {
        target: '#tour-card-properties',
        placement: 'left',
        disableBeacon: true,
        title: '✍️ Select your canvas',
        content:
          'Here you can select the canvas you want to reference. You will see a mini view and the name of the canvas.',
      },

      // ── Step 9: Relations between cards ───────────────
      {
        target: '#tour-relation-btn',
        placement: 'right',
        disableBeacon: true,
        spotlightClicks: true,
        title: '🔗 Relations between cards',
        content:
          'If you have multiple groups, each describing a certain aspect of your story, you can relate them to each other.\n\n' +
          'By clicking this icon you will NOT see a card appear on the canvas but instead a the right panel will show some options to create a relation.',
      },
      // ── Step 10: Create a relation  ───────────────
      {
        target: '#tour-card-properties',
        placement: 'left',
        disableBeacon: false,
        spotlightClicks: true,
        title: '🔗 Create the relation',
        content:
          'Click the "Start card" button in the right panel. Then select a card on the canvas to start the relation from.\n\n' +
          'Then click on the "End card" button in the right panel and select the card you want the relation to end on. ' +
          'This will create a visual connection between the two cards.\n\n' +
          'You can change the type of relation by selecting an existing option from the drop down menu or select "+ Add new type" to add a new one.\n\n' +
          'You can change the color of the line by clicking the colored box, which allows you to give each type of relation a different color.',
      },

      // ── Step 11: Outro ──────────────────────────────────
      {
        target: 'body',
        placement: 'center',
        disableBeacon: true,
        title: '🎊 You\'re a Story Weaver!',
        content:
          'This concludes the special cards tour! ' +
          'Now you know everything about using special cards. ' +
          'Click the 🗺️ Guided Tours button any time to explore the decks and features in more depth.',
      },
    ],
  },
];

export default deckTours;
